import axios, { AxiosResponse } from 'axios';
import { useMemo } from 'react';

import { getApiLink } from '../api';
import { useData } from '../hooks/useData';
import { RecentNewsArticleModel } from '../apiSchema';

async function getRecentNewsArticles(): Promise<RecentNewsArticleModel[]> {
    const response: AxiosResponse<RecentNewsArticleModel[]> = await axios.get(getApiLink('NewsArticle/GetRecentNewsArticle'));

    return response.data;
}

export default function useRecentNewsArticles() {
    const { data: recentNewsArticles, isLoading: isRecentNewsArticlesLoading } = useData<RecentNewsArticleModel[]>(
        [],
        getRecentNewsArticles
    );

    const recentArticleIds = useMemo(() => {
        if (!recentNewsArticles) return [];
        const ids = recentNewsArticles.map((a) => a.id).filter((id): id is number => typeof id === 'number');
        return Array.from(new Set(ids));
    }, [recentNewsArticles]);

    return {
        recentNewsArticles,
        isRecentNewsArticlesLoading,
        recentArticleIds
    };
}
